/**
* Data model that represents the data required to add an appointment
*
* @class AddAppointmentTicket
*/
function AddAppointmentTicket (parent) {
  var self = this;	// Convenience reference so the context of 'this' becomes clearer

  // Observable variables represented by this data model
  self.customProps = ko.observableArray([]);
  self.location = ko.observable(null);
  self.email = ko.observable(null);
  self.firstName = ko.observable(null);
  self.firstQueueId = ko.observable(null);
  self.firstResourceId = ko.observable(null);
  self.lastName = ko.observable(null);
  self.language = ko.observable(null);
  self.notes = ko.observable(null);
  self.parent = parent;
  self.partySize = ko.observable(null);
  self.phone = ko.observable(null);
  self.queueId = ko.observable(null);
  self.recurs = ko.observable(false);
  self.recurrenceInterval = ko.observable(null);
  self.resourceId = ko.observable(null);
  self.start = ko.observable(null);
  self.timeZone = ko.observable(null);
  self.transactionTypeId = ko.observable(null);

  self.resourceBinder = new ResourceBinderWS(self.parent, this);

  this.isLoading = ko.computed(this._isLoading, this, {deferEvaluation: true});

	/**
	* Pass-through observable
	*
	* @method resources
	* @return Array
	*/
  self.resources = ko.computed(function () {
    return self.resourceBinder.resources();
  });


	/**
	* Returns the array of resources available to the UI
	*
	* @method availableResources
	* @return {Array}
	*/
  self.availableResources = ko.computed(function () {
    if (self.transactionTypeId()) {
      return self.getResourcesByTT(self.transactionTypeId());
    }
    else if (self.queueId()) {
      return self.getResourcesByQueue(self.queueId());
    }

    return self.resources();
  }, this, {deferEvaluation: true});


	/*
	* This computed observable is necessary due to the way data binding is done in the new
	* appointment form. A collection bound to qcal.addAppointmentTicket.location().queues will
	* fail because at the time the app is loaded, qcal.addAppointmentTicket.location() is null
	* and has no members. This observable allows a work around to that.
	*
	* @method newAppointmentLocationQueues
	* @return {Array}
	*/
  self.availableQueues = ko.computed(function () {
    var resource = null;

    if (self.firstResourceId()) {
      resource = self.resourceBinder.getResourceById(self.firstResourceId());

      if (resource) {
        return self.queues().filter(function (q) {
          return (resource.queues.indexOf(q.id) > -1);
        });
      }
    }

    return self.queues();
  }, this, {deferEvaluation: true});


	/**
	* Returns a collection of transaction types which can service the specified
	* Queue Id
	*
	* @method getAvailableTransactionTypes
	* @param {Number} iQueueId
	* @return {Array}
	*/
  self.getAvailableTransactionTypes = function (iQueueId) {
    var aTTs = [],
      resource = null;

    if (iQueueId != null) {
      aTTs = qcal.queuesWS.indexedQueues()[iQueueId].transactionTypes();

      if (self.firstResourceId() != null) {
        resource = self.resourceBinder.getResourceById(self.firstResourceId());

        if (resource) {

          return aTTs.filter(function (TT) {
            return (resource.transactionTypes.indexOf(TT.id) > -1);
          });
        }
      }
    }

    return aTTs;
  };


	/**
	* Observable method which recalculates when queueId changes and calls
	* the method availableTransactionTypes()
	*
	* @method availableTransactionTypes
	* @return {Array}
	*/
  self.availableTransactionTypes = ko.computed(function () {
    var iQueueId = self.queueId();

    return self.getAvailableTransactionTypes(iQueueId);
  });


	/**
	* Finds a list of resources by a queue id
	*
	* @method getResourcesByQueue
	* @param {String | Number} id
	* @return {Array}
	*/
  self.getResourcesByQueue = function (id) {
    return self.resources().filter(function (r) {
      return (r.queues.indexOf(Number(id)) > -1);
    });
  };


	/**
	* Finds a list of resources by a transaction type id
	*
	* @method getResourcesByTT
	* @param {String | Number} id
	* @return {Array}
	*/
  self.getResourcesByTT = function (id) {
    return self.resources().filter(function (r) {
      return (r.transactionTypes.indexOf(Number(id)) > -1)
    });
  };


	/**
	* Convenience function to expose selected location queues to the
	* addAppointmentTicket. This enables the change of those queues
	* to be subscribed to.
	*
	* @method queues
	* @return {Array} Collection of queue option objects
	*/
  self.queues = ko.computed(function () {
    var location = self.location(),
      locationQueues = [],
      resource = null;

    if (location) {

      locationQueues = self.location().queues();

      if (self.firstResourceId() != null) {
        resource = self.resourceBinder.getResourceById(self.resourceId());

        if (resource) {
          return locationQueues.filter(function (l) {
            return (resource.queues.indexOf(l.id) > -1);
          });
        }

      }

      return locationQueues;
    }

    return [];
  });


	/**
	* Determines if the first queue selection should be visible
	*
	* @method showFirstQueue
	* @return {Boolean}
	*/
  self.showFirstQueue = ko.computed(function () {
    var l = self.location(),
      r = self.firstResourceId(),
      q = self.queues();

    return l && q.length > 1 && r == null;
  });


	/**
	* Determines if the first resource selection should be visible
	*
	* @method showFirstResource
	* @return {Boolean}
	*/
  self.showFirstResource = ko.computed(function () {
    var l = self.location(),
      r = self.resources(),
      q = self.firstQueueId();

    return l && r.length > 1 && q == null;
  });


	/**
	* Method to determine if the selected location is configured to use Party Size
	*
	* @method usePartySize
	* @return {Boolean}
	*/
  self.usePartySize = ko.computed(function () {
    return (self.location() != null && self.location().usePartySize == true);
  });


	/**
	* Method to get min of Party Size
	*
	* @method minPartySize
	* @return {Number}
	*/
  self.minPartySize = ko.computed(function () {
    var queue = null;
    if (self.queueId()) {
      queue = self.parent.queuesWS.getQueue(self.queueId());
    }
    return (queue && queue.minPartySize) || 1;
  });


  /**
   * Prevents entered numbers from getting out from the given range
   *
   * @method handlePartySizeKeyUp
   * @returns {Boolean}
   */
  self.handlePartySizeKeyUp = function () {
    var partySize = self.partySize();
    var minPartySize = self.minPartySize();
    var maxPartySize = self.maxPartySize();

    if (partySize < minPartySize) {
      self.partySize(minPartySize)
    } else if (partySize > maxPartySize) {
      self.partySize(maxPartySize)
    }

    return true;
  };


	/**
	* Method to get max of Party Size
	*
	* @method maxPartySize
	* @return {Number}
	*/
  self.maxPartySize = ko.computed(function () {
    var queue = null;
    if (self.queueId()) {
      queue = self.parent.queuesWS.getQueue(self.queueId());
    }
    return (queue && queue.maxPartySize) || 99;
  });


	/**
	* Method to reset the appointment ticket to blank values
	*
	* @method reset
	* @return {AddAppointmentTicket} Returns the data model as chainable, for best practice
	*/
  self.reset = function () {
    self.customProps.removeAll();

    self.email(null);
    self.firstName(null);
    self.firstQueueId(null);
    self.firstResourceId(null);
    self.language(null);
    self.lastName(null);
    self.location(null);
    self.notes(null);
    self.partySize(null);
    self.phone(null);
    self.queueId(null);
    self.recurs(false);
    self.recurrenceInterval(null);
    self.resourceId(null);
    self.start(null);
    self.timeZone(null);
    self.transactionTypeId(null);

    // Return self (AddAppointmentTicket) as chainable, for best practice
    return self;
  };


	/**
	* Subscription to watch when the location changes
	* Will re-initialize the custom properties, time blocks,
	* retrieve new custom fields, and request resources
	* assigned to the selected location
	*
	* @method location.subscribe
	* @param {Mixed}
	* @return none
	*/
  self.location.subscribe(function (newVal) {
    var i = 0,
      oLoc = self.location();

    self.customProps.removeAll();
    qcal.possibleTimeBlocksWS.reset();

    if (newVal) {
      if (oLoc != null) {

        // Initiate any custom screens
        oLoc.appointmentCustomScreensWS.doRequest(oLoc.id);

        // Get the Resource bindings
        self.resourceBinder.doRequest();

        // Initiate any appointment transaction types
        // for ( i = 0; i < oLoc.queues().length; i++ ) {
        // 	qcal.queuesWS.indexedQueues()[ oLoc.queues()[i].id ].appointmentTransactionTypesWS.doRequest();
        // }
      }
    }
  });


	/**
	* When the firstQueueId is changed ( either to null or a value)
	* set the queueId to match and then clear out all the other two
	* dependent values for a fresh start
	*
	* @method firstQueueId.subscribe
	* @return none
	*/
  self.firstQueueId.subscribe(function (queueId) {
    self.queueId(queueId);
    self.resourceId(null);
    self.transactionTypeId(null);
  });


	/**
	* When the firstResourceId is changed ( either to null or a value)
	* set the resourceId to match and then clear out all the other two
	* dependent values for a fresh start
	*
	* @method firstResourceId.subscribe
	* @return none
	*/
  self.firstResourceId.subscribe(function (resourceId) {
    self.queueId(null);
    self.resourceId(resourceId);
    self.transactionTypeId(null);
  });


	/**
	* Observable to watch the queueId observable and set the TT
	*
	* @method queueId.subscribe
	* @return none
	*/
  self.queueId.subscribe(function (iQueueId) {
    if (iQueueId != null) {

      // If there is only one queue, go ahead and set it on the possibleTimeBlocks
      // and the addAppointmentTicket. Otherwise, allow the user to select the TT in the interface
      if (self.availableTransactionTypes().length == 1) {

        setTimeout(function () {
          var tts = self.getAvailableTransactionTypes(iQueueId);

          self.transactionTypeId(tts[0].id);
        }, 500);
      }


    }
    else {
      // Make sure the TT is rest
      self.transactionTypeId(null);
    }

    setTimeout(function () {
      try {
        window.qcal.loadPossibleTimeBlocks(iQueueId);
      }
      catch (e) {
        console.error(e)
      }
    }, 500);

  }.bind(this));

  /**
   * 
   * Attempt to autoselect the Resource when the Resources change.
   * @method availableResources.subscribe
   */
  self.availableResources.subscribe(function () {
    self.autoselectResource();
  })


	/**
	* #QCAL-163
	* If the selected location only has one queue, set the
	* addAppointmentTicket.queueId accordingly
	*
	* @method queues.subscribe
	* @return
	*/
  self.queues.subscribe(function (queues) {
    if (queues.length == 1) {

      // This feels like a hack, but I have tried this a couple different
      // ways and each time a timeout is required to allow the UI time to
      // bind the data. Without the timeout, the queueId() value is set,
      // then the UI is rendered, which sets the queueId back to undefined
      setTimeout(function () {
        self.queueId(queues[0].id);
      }, 200);
    }

  });


	/**
	* Initiates a call to the possible time blocks service
	*
	* @method requestPossibleTimeBlocks
	* @return none
	*/
  self.requestPossibleTimeBlocks = function () {

    qcal.possibleTimeBlocksWS.doRequest(function () {
      // This function sets the view to the wee which contains
      // the first possible time block, in case it is not contained
      // within the current view.
      var firstBlockDate = null;

      // If the possibleTimeBlocksWS service returned data,
      // set the date view to the first found date
      if (qcal.possibleTimeBlocksWS.blocks().length > 0) {

        // Pull out the first (earliest) time block
        firstBlockDate = qcal.possibleTimeBlocksWS.blocks()[0].getDate();

        // Hijack a click handler method to set the view to the
        // first available date
        qcal.setCalDate({ 'date': firstBlockDate }, 'false');

        // Scroll the view to the hour of the first available
        // appointment spot
        qcal.scrollViewToHour(firstBlockDate);

      }
      else {
        // TODO
        // Handle no time blocks returned.
      }
    });
  };


	/**
	* Creates a subscription to the transactionTypeId and initiates a call to
	* the possibleTimeBlocksWS service
	*
	* @method transactionTypeId.subscribe
	* @return none
	*/
  self.transactionTypeId.subscribe(function (iTTId) {
    var aTTs = [],
      queueId = self.queueId();

    if (qcal) {

      if (queueId) {
        aTTs = self.availableTransactionTypes();
      }

      if (iTTId != null && aTTs.length != 1) {
        qcal.possibleTimeBlocksWS.transactionTypeIds(iTTId);
        self.requestPossibleTimeBlocks();
      }
    }

  });


	/**
	* Creates a subscription to the resourceId and initiates a call to
	* the possibleTimeBlocksWS service
	*
	* @method resourceId.subscribe
	* @return none
	*/
  self.resourceId.subscribe(function (resourceId) {
    if (qcal) {

      if (resourceId) {
        qcal.possibleTimeBlocksWS.resourceId(resourceId);

        if (self.transactionTypeId() != null) {
          self.requestPossibleTimeBlocks();
        }
      }
      else {
        qcal.possibleTimeBlocksWS.resourceId(null);
      }
    }
  });


	/**
	* Whether sufficient flags have been set to show resources
	*
	* @method showResources
	* @return {Boolean}
	*/
  self.showResources = ko.computed(function () {
    if (!self.parent.merchantWS.resourceAppointmentEnabled()) {
      return false;
    }

    var location = self.location();

    if (location) {
      var selectionIsImplicitlyAllowed = self.parent.locationsWS.allowResourceSelection(location.id)
      if (selectionIsImplicitlyAllowed) {
        return selectionIsImplicitlyAllowed
      }
    }

    if (self.parent.merchantWS.allowResourceSelection() != null) {
      return self.parent.merchantWS.allowResourceSelection();
    }

    return false;
  });



  // Return self (AddAppointmentTicket) to be chainable, for best practice
  return self;
}

/**
 * If there is only one available Resource, pre-select it.
 */
AddAppointmentTicket.prototype.autoselectResource = function () {
  var resources = this.availableResources();

  // If there is only one Resource, pre-select it.
  if (resources.length == 1) {
    var resourceId = resources[0].id;
    this.resourceId(resourceId)

    // The subscription to resourceId will pickup this change and update the 
    // possibleTimeBlocksWS parameter.
    // In this way, we don't create a hard dependency between these two components.
  }
}

/**
 * If there is only one selected Location, pre-select it when adding an
 * Appointment.
 */
AddAppointmentTicket.prototype.autoselectLocation = function() {
  var selectedLocationIds = this.parent.selectedLocationIds();
  if (selectedLocationIds.length == 1) {
    this.location(this.parent.locationsWS.getLocationById(Number(selectedLocationIds[0])));
  }
}

AddAppointmentTicket.prototype.autoselectQueue = function() {
  if (this.location()) {
    // If there is only one queue, we will pre-select it like we did with location.
    var queues = this.parent.queuesWS.getQueuesByLocationId(this.location().id)
    if (queues.length == 1) {
      this.queueId(queues[0].id);
    }
  }

  // NOTE:
  // These auto-select functions operate synchronously assuming that the data required
  // from LocationsWS and QueuesWS is already present (it should be and that's why we have 
  // the loading check now ) but ideally, these should be asynchronous.
  //
  // That is, getQueuesByLocationId() should actually accept a callback wherein
  // we check the length of queues and then do the auto-select.
}

AddAppointmentTicket.prototype.init = function () {
  this.autoselectLocation();
  this.autoselectQueue();
}

/**
 * Indicates whether the information required to schedule an Appointment
 * is available or not.
 *
 * This method is used to defer showing the Add Appointment form until
 * the information is present so that we can perform any autoselections
 * before the user can interact with the UI.
 *
 * Actual usage should refer to the {@link AddAppointmentTicket#isLoading} 
 * computed observable.
 *
 * @returns boolean
 */
AddAppointmentTicket.prototype._isLoading = function () {
  return !this.availableQueues() && !this.availableResources()
}

if (typeof exports !== "undefined") {
  exports.AddAppointmentTicket = AddAppointmentTicket;
}
